<template>
  <div id="my_hire">
    <!--  style="height:48px;position:fixed;top:0;width:100%" -->
    <div style="position: sticky; top: 0; z-index: 9">
      <van-tabs v-model="activeType" lazy-render title-active-color="rgba(51, 51, 51, 1)" title-inactive-color="#999999"
        @change="onChange(activeType)" animated>
        <van-tab v-for="index in tabList" :key="index.name" :name="index.name">
          <template #title>
            {{ index.title }}
            <van-badge dot v-if="index.title == '销售申请' && salesApprovalQuantity > 0" style="position: absolute">
            </van-badge>
            <!-- <div
              class="iconReed"
              v-if="index.title == '销售申请' && salesApprovalQuantity > 0"
            >
            </div> -->
          </template>
        </van-tab>
      </van-tabs>
      <div v-if="activeType == 2" style="border-top: 1px solid rgba(230, 230, 230, 1)">
        <van-tabs v-model="activeNum" lazy-render title-active-color="rgba(51, 51, 51, 1)"
          title-inactive-color="#999999" @change="onClickChange(activeNum)" animated>
          <van-tab v-for="index in tabApplyList" :key="index.name" :name="index.name" :title="index.title">
          </van-tab>
        </van-tabs>
      </div>

      <div class="SalesPerformancebox" v-if="activeType == 0">
        <div class="my_hire_mounth">
          <span class="SalesPerformanceTime">时间</span>
          <div class="share_mounth_change">
            <div class="monthItem" @click="onDataChange">
              <div>
                {{ isChooseDate }}
              </div>
              <van-icon name="arrow-up" v-if="showmonthData" size="12px" color="#c8c8c8"
                style="width: 12px; height: 12px; margin-left: 3px" />
              <van-icon name="arrow-down" v-else size="12px" color="#c8c8c8"
                style="width: 12px; height: 12px; margin-left: 3px" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我的业绩 -->
    <div v-if="activeType == 1" id="my_hire_first">
      <div class="my_hire_list">
        <div class="SalesPerformance_item betweentop" id="my_hire_record" v-for="(item, index) in hireList"
          :key="index">
          <div class=" between">
            <div class="Sales_i">
              <div class="ellipsis name">
                {{ item.saleYear + "年" + item.saleMonth + "月" }}
              </div>
            </div>
            <div class="betweenBottoms my_hier_size">{{ item.quantity }}盒</div>
          </div>

          <div class="SpecialtyGoods" v-if="item.details.length">
            <div>特殊产品展示</div>
            <div class="between topGoods"  v-for="v in item.details" :key="v.goodsId">
              <div class="goodsLeft">{{ v.name }}</div>
                  <div>x{{ v.quantity }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footerProfit" v-if="hireList.length != 0">
        展示最近6个月的数据
      </div>
    </div>
    <div v-if="activeType == 0 && hireList.length != 0" class="my_hire_concent_box">
      <!-- 分页 -->
      <van-list v-model="loading" :finished="finished" finished-text="暂无更多" @load="onLoad" :immediate-check="false">
        <!-- 销售业绩-->
        <div id="my_hire_first">
          <div class="my_hire_list">
            <div class="my_hire_list_item betweentop" v-for="(item, index) in hireList" :key="index"
              @click="click(item)">
              <!-- <div> -->
              <div class=" between">
                <div class="flex betweenBottom">
                  <div class="avar">
                    <img :src="item.avatarUrl" alt />
                  </div>
                  <div class="nickName ellipsis name">
                    {{ item.nickName }}
                  </div>
                </div>

                <div class="betweenBottoms my_hier_size">
                  {{ item.quantity }}盒
                </div>
              </div>
              <!-- </div> -->
              <div class="SpecialtyGoods" v-if="item.buyGoodsCountDtos.length">
                <div>特殊产品展示</div>
                <div class="between topGoods" v-for="(i, index1) in item.buyGoodsCountDtos" :key="index1">
                  <div class="goodsLeft">{{ i.name }}</div>
                  <div>x{{ i.quantity }}</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div v-if="activeType == 2 && hireList.length != 0" class="my_hire_concent_box">
      <!-- 分页 -->
      <van-list v-model="loading" :finished="finished" finished-text="暂无更多" @load="onLoad" :immediate-check="false">
        <!-- 销售申请 -->
        <div id="my_hire_first">
          <div class="my_hire_list">
            <div class="my_hire_list_item" id="my_hire_record" v-for="(item, index) in hireList" :key="index">
              <div class="Sales_i between">
                <div class="avar">
                  <img :src="item.avatarUrl" alt />
                </div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.nickName }}
                </div>
              </div>
              <div class="Sales_i between">
                <div class="titleL">申请编号</div>
                <div class="betweenBottoms my_hier_size">{{ item.id }}</div>
              </div>
              <div class="Sales_i between">
                <div class="titleL">云电编号</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.ydCode }}
                </div>
              </div>
              <div class="Sales_i between">
                <div class="titleL">申请时间</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.createTime }}
                </div>
              </div>
              <div class="Sales_i between">
                <div class="titleL">审批状态</div>
                <div class="betweenBottoms my_hier_size">
                  {{ getChinese(item.saleStatus) }}
                </div>
              </div>
              <div :class="item.saleStatus == 3
                ? 'Sales_i between'
                : 'Sales_Button between'
                " v-if="item.saleStatus == 2 || item.saleStatus == 3">
                <div class="titleL">确认时间</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.confirmTime }}
                </div>
              </div>
              <div :class="item.saleStatus == 4 || item.saleStatus == 5
                ? 'Sales_i between'
                : 'Sales_Button between'
                " v-if="
                  item.saleStatus == 3 ||
                  item.saleStatus == 4 ||
                  item.saleStatus == 5
                ">
                <div class="titleL">审批时间</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.checkTime }}
                </div>
              </div>
              <div class="Sales_Button between" v-if="item.saleStatus == 4 || item.saleStatus == 5">
                <div class="titleL">驳回原因</div>
                <div class="betweenBottoms my_hier_size">
                  {{ item.reason }}
                </div>
              </div>
              <div class="Sales_Button" @click="onClickItem(item)" v-if="item.saleStatus == 1">
                <van-button type="danger" block native-type="submit" style="border-radius: 8px">确认</van-button>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>

    <!-- 月份弹窗 -->
    <van-popup v-model="showmonthData" round position="bottom">
      <van-picker show-toolbar :columns="monthData" @confirm="onConfirm" @cancel="onCancel" />
    </van-popup>
    <!--提交销售申请  -->
    <van-dialog v-model="close" @confirm="onApplyConfirm" :showConfirmButton="false">
      <div class="applyContent">
        <div class="applyContentTitle">业绩详情</div>
        <van-icon name="cross" color="rgba(153, 153, 153, 1)" class="applyContentIcon" @click="onDetailCancel" />
        <div class="dialogSales">
          <div class="Sales_item between">
            <div class="avar">
              <img :src="performanceDetail.avatarUrl" alt />
            </div>
            <div class="boxR">
              {{ performanceDetail.nickName }}
            </div>
          </div>
          <div class="Sales_item between">
            <div class="boxL">时间</div>
            <div class="boxR">
              {{ currentMonth }}
            </div>
          </div>
          <div class="Sales_item between">
            <div class="boxL">盒数</div>
            <div class="boxR">{{ performanceDetail.quantity }}盒</div>
          </div>
        </div>
      </div>
    </van-dialog>
    <!-- loading -->

    <!-- <div class="wrapper"> -->
    <loading v-if="isLoading"></loading>
    <!-- </div> -->
    <!-- 空页面 -->
    <div class="noShares" v-if="hireList.length == 0">
      <div class="noSalePage">
        <img src="../../../assets/images/noSale.png" alt v-if="activeType == 0" />
        <img src="../../../assets/images/noApply.png" alt v-if="activeType == 2" />
      </div>
      <div class="noShareText" v-if="activeType == 0">暂无销售</div>
      <div class="noShareText" v-if="activeType == 2">暂无申请</div>
    </div>
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Toast,
  Dialog,
  List,
  Loading,
  Overlay,
  Popup,
  Icon,
  Picker,
  Badge,
} from "vant";
import loading from "../../components/loading/loading";
import { mapGetters } from "vuex";
import saleService from "../../api/salesPerformance/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [List.name]: List,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [Badge.name]: Badge,
    loading,
  },
  props: {},
  data() {
    return {
      // tablist
      tabList: [
        { name: 0, title: "销售业绩" },
        { name: 1, title: "我的业绩" },
        { name: 2, title: "销售申请" },
      ],
      tabApplyList: [
        { name: 1, title: "待确认" },
        { name: 2, title: "待审批" },
        { name: 3, title: "已通过" },
        { name: "4,5", title: "已驳回" },
      ],
      active: 0,
      activeNum: 1,
      activeType: 0,
      isChooseDate: "",
      showmonthData: false,
      currentMonth: "",
      monthData: [],
      isLoading: true,
      page: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      hireList: [],
      hirePerson: "",
      close: false,
      salesApprovalQuantity: 0,
      performanceDetail: {
        // avar: "",
        // name: "张三",
        // time: "2025年02月",
        // number: "100盒",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    getChinese(status) {
      switch (status) {
        case 1:
          return "待确认";
        case 2:
          return "待审批";
        case 3:
          return "已通过";
        case 4:
          return "已驳回";
        case 5:
          return "已驳回";

        default:
          return status;
      }
    },
    // tab切换
    onChange(active) {
      this.page = 1;
      this.pageSize = 20;
      this.hireList = [];
      this.isLoading = true;
      this.finished = false;
      this.activeType = active;
      this.active = active;

      this.getlist();
    },
    // 销售申请tab切换
    onClickChange(activeNum) {
      this.page = 1;
      this.pageSize = 20;
      this.isLoading = true;
      this.finished = false;

      this.activeNum = activeNum;
      this.hireList = [];
      this.getlist();
    },
    // 月份选择确认
    onConfirm(value) {
      this.isChooseDate = value.text;
      this.currentMonth = value.date;
      this.showmonthData = false;
      this.page = 1;
      this.pageSize = 20;
      this.hireList = [];
      this.getlist();
    },

    // 月份取消
    onCancel() {
      this.showmonthData = false;
    },
    // 点击显示日期弹窗
    onDataChange() {
      this.showmonthData = true;
    },
    // 年月转换 // date 数字类型
    getMonth(month) {
      switch (month) {
        case 1:
          return "一月";
        case 2:
          return "二月";
        case 3:
          return "三月";
        case 4:
          return "四月";
        case 5:
          return "五月";
        case 6:
          return "六月";
        case 7:
          return "七月";
        case 8:
          return "八月";
        case 9:
          return "九月";
        case 10:
          return "十月";
        case 11:
          return "十一月";
        case 12:
          return "十二月";
        default:
          break;
      }
    },
    // 获取年月
    getFullMonth() {
      // try {
      saleService
        .GetDateByMonthNum(6)
        .then((res) => {
          if (res.statusCode == 200) {
            res.data.map((i) => {
              i.text = this.getMonth(i.monthDate);
              i.text = i.date;
              // i.disabled = !i.isTrue
              if (i.isCurrent == true) {
                this.isChooseDate = this.getMonth(i.monthDate);
                this.isChooseDate = i.date;
                // this.defaultIndex = i.monthDate - 1
                this.currentMonth = i.date;
              }
            });
            this.monthData = res.data;
            this.isLoading = false;
            this.getlist();
            // this.onLoad();
          } else {
            Toast(res.errors);
          }
        })
        .catch((err) => {
          Toast(err);
        });
      this.getQuantity();
      // } catch (error) {
      // } finally {
      //   this.isLoading = false;
      // }
    },
    getQuantity() {
      // 获取销售审批待确认数量
      saleService.GetSalesApprovalQuantity().then((res) => {
        if (res.statusCode == 200) {
          this.salesApprovalQuantity = res.data;
        }
      });
    },
    hireNow() {
      this.$router.push("hireAplication");
    },
    // 确认
    onClickItem(item) {
      this.isLoading = true;
      // this.close = true;

      saleService
        .post({ userId: item.mallUserId })
        .then((res) => {
          if (res.statusCode == 200 && res.data) {
            this.page = 1;
            this.pageSize = 20;
            this.hireList = [];
            this.getlist();
            this.getQuantity();
          } else {
            Toast("确认失败");
          }
        })
        .catch((err) => {
          Toast(err);
          this.isLoading = false;
        });
    },
    // 点击每一个获取详情
    click(item) {
      this.close = true;
      this.performanceDetail = item;
      // saleService.post().then((res) => {
      //   if (res.statusCode == 200) {
      //     this.performanceDetail = res.data;
      //   }
      // });
    },
    onApplyConfirm() {
      this.close = false;
    },
    onDetailCancel() {
      this.close = false;
    },
    //下拉加载列表
    getlist() {
      this.finished = false;
      this.loading = false;
      this.onLoad();
    },
    approvalList() {
      this.isLoading = true;
      // try {
      saleService
        .GetSalesApprovalList(this.activeNum, this.page, this.pageSize)
        .then((res) => {
          if (res.statusCode == 200) {
            this.loading = false;
            this.finished = false;
            // this.hireList = res.data.hirePerson;
            const results = res.data.items;
            this.hireList.push(...results);

            this.isLoading = false;
            if (res.data.totalCount > this.hireList.length) {
              // 有，则更新获取下一个数据的页码
              this.page++;
            } else {
              this.finished = true;
            }
          } else {
            this.isLoading = false;
            Toast(errors);
          }
        });
      // } catch (error) {
      // } finally {
      //   this.isLoading = false;
      // }
    },
    onLoad() {
      this.isLoading = true;
      console.log(
        11111111111111,
        this.monthData,
        this.monthData != undefined &&
        this.monthData != null &&
        this.monthData != ""
      );
      if (
        this.monthData != undefined &&
        this.monthData != null &&
        this.monthData != ""
      ) {
        var before = this.currentMonth.split("-")[0];
        var after =
          this.currentMonth.split("-")[1] < 10
            ? this.currentMonth.split("-0")[1]
            : this.currentMonth.split("-")[1];
        if (this.activeType == 0) {
          saleService
            .GetSalesRecord(before, after, this.page, this.pageSize)
            .then((res) => {
              if (res.statusCode == 200) {
                const results = res.data.items;
                this.hireList.push(...results);
                this.isLoading = false;
                this.loading = false;
                this.finished = false;
                if (res.data.totalCount > this.hireList.length) {
                  // 有，则更新获取下一个数据的页码
                  this.page++;
                } else {
                  this.finished = true;
                }
              } else {
                this.isLoading = false;
                Toast(errors);
              }
            });
        }
      }
      if (this.activeType == 1) {
        saleService
          .GetMySalesRecord(this.page, this.pageSize)
          .then((res) => {
            if (res.statusCode == 200) {
              const result = res.data;
              this.hireList = result;
              this.isLoading = false;
            } else {
              Toast(errors);
              this.isLoading = false;
            }
          })
          .catch((err) => {
            this.isLoading = false;
            // Toast(err);
          });
      }
      if (this.activeType == 2) {
        this.approvalList();
      }
    },
  },
  created() { },
  mounted() {
    // this.onLoad()
    this.activeType = this.$route.query.status;
    this.active = this.$route.query.status;
    this.isLoading = true;
    this.getFullMonth();
  },
  computed: {
    ...mapGetters(["agentShow"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },
};
</script>
<style lang="less">
.SalesProduct {
  margin-top: 8px;
}

.SpecialtyGoods {
  color: rgba(71, 85, 105, 1);
  font-size: 14px;
  line-height: 22px;
  padding-top: 16px;
  margin-top: 16px;
  border-top: 1px solid rgba(226, 232, 240, 1);
}

.goodsLeft {
  margin-right: 40px;
}

.topGoods {
  padding-top: 12px;
}

#my_hire {
  width: 100%;
  min-height: 100vh;
  background: #f8f8f8;

  .noSalePage {
    width: 80px;
    margin: auto;
  }

  .titleL {
    width: 160px;
    // margin-right: 20px;
  }

  // .my_hire_concent_box {
  // padding-bottom: 60px;
  // padding-top: 48px;
  // }
  .van-list__finished-text {
    height: 44px;
    line-height: 44px;
    font-size: 12px;
  }

  .van-tabs__wrap {
    height: 48px !important;
  }

  .avar {
    width: 48px;
    height: 48px;

    img {
      border-radius: 50%;
    }
  }

  .betweentop {
    margin-top: 8px;
    padding: 16px;
  }

  .nickName {
    margin-left: 12px;
  }

  .name {
    width: 160px;
    word-break: break-all;
    line-height: 22px;
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .my_hier_size {
    line-height: 22px;
    text-align: end;
    word-break: break-all;
  }

  .noShares {
    height: 100;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #92909a;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .noShareText {
    padding-top: 24px;
  }

  .SalesPerformancebox {
    height: 56px;
    line-height: 56px;
    padding: 0 16px;
    font-size: 14px;
    background: #f8f8f8;
    color: #333333;

    .my_hire_people {
      height: 64px;
      line-height: 64px;
      float: left;
    }

    .my_hire_mounth {
      display: flex;

      .my_hire_data {
        margin-right: 8px;
      }

      .monthItem {
        // min-width: 48px;
        // width: 100%;
        height: 40px;
        line-height: 40px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e6e6e6;
        padding: 0 14px 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .share_mounth {
        display: inline-block;
        vertical-align: top;
      }

      .SalesPerformanceTime {
        padding-right: 12px;
      }

      .share_mounth_change {
        width: 100%;
        flex: 1;
        padding-top: 8px;
        // display: inline-block;
        // vertical-align: middle;
      }
    }
  }

  #my_hire_first {
    .my_hire_list_item:first-child {
      margin-top: 0px;
    }

    #my_hire_record:first-child {
      margin-top: 12px;
    }

    .my_hire_list {
      padding: 0 12px;

      .SalesPerformance_item {
        padding: 20px;
        // height: 40px;
        background: #ffffff;
        box-shadow: 0px 4px 8px 0px #e6e6e6;
        border-radius: 8px;
      }

      .my_hire_list_item {
        padding-left: 16px;
        padding-right: 16px;
        // height: 40px;
        background: #ffffff;
        // box-shadow: 0px 4px 8px 0px #e6e6e6;
        border-radius: 8px;
        margin-top: 8px;

        .Sales_i {
          // float: left;
          // margin-right: 12px;
          padding-bottom: 20px;
          padding-top: 20px;
          border-bottom: 1px solid rgba(230, 230, 230, 1);
          // line-height: 22px;
        }

        .Sales_Button {
          padding-bottom: 20px;
          padding-top: 20px;
        }

        #my_hire_record_left {
          margin-right: 0;
        }

        .my_hire_record_right {

          // float: right;
          div {
            height: 40px;
            line-height: 40px;
          }

          .my_hire_record_scuess {
            color: #19c15c;
            font-weight: 600;
          }

          .my_hire_record_fail {
            color: #f00724;
            font-weight: 600;
          }

          .my_hire_record_wait {
            color: #faad14;
            font-weight: 600;
          }
        }
      }
    }
  }

  .applyContent {
    position: relative;
    line-height: 14px;
    color: rgba(51, 51, 51, 1);

    .applyContentIcon {
      position: absolute;
      right: 16px;
      top: 16px;
      color: rgba(153, 153, 153, 1);
    }

    .applyContentTitle {
      font-size: 16px;
      font-weight: 600;
      line-height: 48px;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      border-bottom: 0.5px solid rgba(230, 230, 230, 1);
    }

    .boxR {
      flex: 1;
      text-align: end;
    }

    .boxL {
      flex: 1;
      color: rgba(102, 102, 102, 1);
    }
  }

  .dialogSales {
    padding-left: 16px;
    padding-right: 16px;
    font-size: 14px;

    .Sales_item {
      padding: 20px 0;
      border-bottom: 0.5px solid rgba(230, 230, 230, 1);
    }
  }

  .footerProfit {
    font-size: 12px;
    line-height: 12px;
    color: rgba(200, 200, 200, 1);
    text-align: center;
    margin-top: 16px;
    margin-bottom: 16px;
  }
}
</style>
